import src from "IMAGE";
export default { src, width: 241, height: 241, blurWidth: 0, blurHeight: 0};
